import React, { Suspense, lazy } from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import { LayoutSplashScreen } from "../../../_metronic";

const DashboardPage = lazy(() => import("./dashboard/DashboardPage"));
const GroupPage = lazy(() => import("./group/GroupPage"));
const AdminPage = lazy(() => import("./admin/AdminPage"));
const RelatorioPage = lazy(() => import("./relatorio/RelatorioPage"));
const RepresentantePage = lazy(() => import("./representante/RepresentantePage"));
const ContaBancariaPage = lazy(() => import("./conta-bancaria/ContaBancariaPage"));
const TagPage = lazy(() => import("./tag/TagPage"));
const FornecedorPage = lazy(() => import("./fornecedor/FornecedorPage"));
const CooperativaPage = lazy(() => import("./cooperativa/CooperativaPage"));
const AssociadoPage = lazy(() => import("./associado/AssociadoPage"));
const ComercialPage = lazy(() => import("./comercial/ComercialPage"));
const ContratoPage = lazy(() => import("./contrato/ContratoPage"));
const FaturaPage = lazy(() => import("./fatura/FaturaPage"));
const CooperativaPagamentoPage = lazy(() => import("./cooperativa-pagamento/CooperativaPagamentoPage"));
const TerceiroPage = lazy(() => import("./terceiro/TerceiroPage"));
const EventoPage = lazy(() => import("./evento/EventoPage"));
const EnvioPage = lazy(() => import("./envio/EnvioPage"));
const NotificacaoPage = lazy(() => import("./notificacao/NotificacaoPage"));
const ProdutoPage = lazy(() => import("./produto/ProdutoPage"));
const FinanceiroEventoPage = lazy(() => import("./financeiro-evento/FinanceiroEventoPage"));
const SolicitacaoPage = lazy(() => import("./solicitacao/SolicitacaoPage"));

export default function HomePage() {
    return (
        <Suspense fallback={<LayoutSplashScreen />}>
            <Switch>
                {<Redirect exact from="/" to="/dashboard" />}

                <Route path="/dashboard" component={DashboardPage} />
                <Route path="/group" component={GroupPage} />
                <Route path="/admin" component={AdminPage} />
                <Route path="/relatorio" component={RelatorioPage} />
                <Route path="/representante" component={RepresentantePage} />
                <Route path="/conta-bancaria" component={ContaBancariaPage} />
                <Route path="/tag" component={TagPage} />
                <Route path="/fornecedor" component={FornecedorPage} />
                <Route path="/master-associado" component={CooperativaPage} />
                <Route path="/associado" component={AssociadoPage} />
                <Route path="/comercial" component={ComercialPage} />
                <Route path="/contrato" component={ContratoPage} />
                <Route path="/fatura" component={FaturaPage} />
                <Route path="/master-associado-pagamento" component={CooperativaPagamentoPage} />
                <Route path="/terceiro" component={TerceiroPage} />
                <Route path="/evento" component={EventoPage} />
                <Route path="/envio" component={EnvioPage} />
                <Route path="/notificacao" component={NotificacaoPage} />
                <Route path="/produto" component={ProdutoPage} />
                <Route path="/financeiro-evento" component={FinanceiroEventoPage} />
                <Route path="/solicitacao" component={SolicitacaoPage} />

                <Redirect to="/error/error-v6" />
            </Switch>
        </Suspense>
    );
}
